<template>
    <div class="vx-row">
        <vs-popup title="Add SVD Location Mapping" :active.sync="showPopUp" type="filled">
            <div class="vx-col md:w-4/4 w-full mb-2">
                <div class="w-full flex flex-no-wrap">
                    <div class="vx-col w-full p-2">
                        <vx-card title="" class="mb-4" v-if="renderComponent">
                            <div class="vx-row mb-6">
                                <div class="vx-col w-full flex flex-no-wrap">
                                    <div class="w-3/12 p-1">
                                        <span>Download File</span>
                                    </div>
                                    <div class="w-9/12 p-1">
                                        <vs-button id="btn-download-sample-configuration-chip-based"
                                            class="mb-4 md:mb-4 w-full" @click="downloadExcel()" icon-pack="feather"
                                            icon="icon-credit-card">Sample File</vs-button>
                                    </div>
                                </div>
                                <div class="vx-col w-full">
                                    <span>Upload file</span> <span class="text-danger">*</span>
                                </div>
                                <div class="vx-col w-full">
                                    <div class="vx-row flex flex-no-wrap">
                                        <custom-upload id="fil-upload-approve-by-id-file" style="padding-top: 1px"
                                            title="File" :file-name="documents[0].file_name"
                                            :on-change-callback="handleFileUpload" :on-delete-callback="handleDelete" />
                                    </div>
                                    <div class="w-full self-center" style="font-size: 12px">
                                        * File must be in .xlxs format <br>
                                    </div>

                                </div>
                            </div>
                        </vx-card>
                    </div>
                </div>
            </div>
            <div id="btn-add-container">
                <vs-button class="btn-add-mapping" id="btn-add-mapping" @click="submitRequest" color="primary"
                    type="gradient">Upload</vs-button>
            </div>
        </vs-popup>
        <vx-card>
            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">
                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * limit - (limit - 1) }} - {{ dataCount - currentPage * limit
                                > 0 ? currentPage * limit : dataCount }} of {{ dataCount }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu id="ddl-page-limit">
                            <vs-dropdown-item id="ddl-page-limit-1" @click="fetchData(1, 20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-2" @click="fetchData(1, 50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-3" @click="fetchData(1, 100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-4" @click="fetchData(1, 150)">
                                <span>150</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item id="ddl-page-limit-5" @click="fetchData(1, totalData)">
                                <span>Show All</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <!-- Add Location Mapping-->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-button id="btn-export-csv" color="success" class="mb-4 mr-4 md:mb-0" @click="exportCSV()">Export to
                        CSV</vs-button>
                    <vs-button id="btn-export-csv" class="mb-4 mr-4 md:mb-0" @click="addSVDLocationMapping">Add SVD Location
                        Mapping</vs-button>
                    <vs-button id="btn-export-csv" color="#193498" class="mb-4 md:mb-0" @click="uploadCSV()">Upload
                        Excel File</vs-button>
                </div>
            </div>

            <ag-grid-vue :gridOptions="gridOptions" class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs" :defaultColDef="defaultColDef" :rowData="locationMapping" rowSelection="multiple"
                colResizeDefault="shift" :animateRows="true" :floatingFilter="true" :pagination="true"
                :paginationPageSize="limit" :suppressPaginationPanel="true" :enableCellTextSelection="true"></ag-grid-vue>
            <vs-pagination :total="totalPage" :max="maxPageNumbers" v-model="currentPage" />
        </vx-card>
    </div>
</template>

<script>
import XLSX from "xlsx"
import swal from "sweetalert2";
import { saveAs } from 'file-saver';
import { url } from "@/configs/apiUrl";
import { AgGridVue } from "ag-grid-vue";
import AxiosCall from "@/global/AxiosCall";
import Excel from "exceljs/modern.browser";
import FileAPI from "@/network/api/FileAPI";
import CustomUpload from "@/components/upload/custom-upload";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import ActionTableAgGridComponent from "@/components/cell-render-component/ActionTableEditDelDeviceAndLocationMapping";

export default {
    name: "SVDLocationMapping",
    components: {
        AgGridVue,
        CustomUpload,
        FileAPI
    },
    data() {
        return {
            renderComponent: true,
            locationMapping: [],
            locationMappingCSV: [],
            loading: false,
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true,
                filterParams: {
                    applyButton: true,
                    newRowsAction: 'keep'
                },
            },
            columnDefs: [
                {
                    headerName: "No",
                    field: "no",
                    width: 75,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "PTO Name",
                    field: "pto_name",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Merchant ID",
                    field: "merchant_id",
                    width: 150,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Merchant Code",
                    field: "merchant_code",
                    width: 170,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Merchant Name",
                    field: "merchant_name",
                    width: 300,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Location ID",
                    field: "location_id",
                    width: 200,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Location Name",
                    field: "location_name",
                    width: 300,
                    filter: true,
                    editable: false,
                },
                {
                    headerName: "Actions",
                    field: "id",
                    filter: false,
                    sortable: false,
                    width: 200,
                    cellRendererFramework: ActionTableAgGridComponent
                }
            ],
            dataCount: 0,
            totalPage: 0,
            page: 1,
            limit: 0,
            totalData: 0,
            showPopUp: false,
            file: null,
            documents: [
                {
                    name: "Configuration",
                    file_name: "",
                    url: ""
                },
            ],
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("Channel", null);
            } else this.gridOptions.columnApi.setColumnPinned("Channel", "left");

        },
    },
    computed: {
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1;
            },
            set(val) {
                this.fetchData(val, this.limit);
            }
        }
    },
    methods: {
        forceRerender() {
            this.renderComponent = false
            this.$nextTick(() => {
                this.renderComponent = true
            })
        },
        addSVDLocationMapping() {
            this.$router.push({ name: "AddSVDLocationMapping" })
        },
        openLoading() {
            this.$vs.loading({
                type: "default"
            });
        },
        fetchData(page, limit) {
            this.page = page
            this.limit = limit
            let newPage = page;
            if (this.dataCount != 0) {
                let totalPages = Math.ceil(this.dataCount / limit);
                if (page > totalPages) {
                    newPage = this.totalPages
                }
            }
            newPage;

            let newUrl = url.svd.svd_location_mapping.list + "?page=" + page + "&limit=" + limit

            this.openLoading();
            AxiosCall.Get(newUrl).then(res => {
                this.$vs.loading.close();
                this.locationMapping = [];
                this.dataCount = 0
                this.totalPage = 0
                if (res.data.length !== 0) {
                    this.totalData = parseInt(res.data.total)
                    let no = 1 + ((res.data.page - 1) * res.data.perPage)
                    for (let data of res.data.data) {
                        data.no = no
                        this.locationMapping.push(data);
                        no++
                    }
                    this.dataCount = res.data.total;
                    this.page = page;
                    if (limit >= this.dataCount) {
                        this.limit = this.locationMapping.length
                    } else {
                        this.limit = limit;
                    }
                    this.gridApi.paginationSetPageSize(this.limit);
                    this.totalPage = res.data.lastPage;
                } else {
                    this.totalData = parseInt(res.data.total)
                }
            }).catch(e => {
                console.log(e)
                this.$vs.loading.close();
                this.locationMapping = [];
                this.dataCount = 0
                this.totalPage = 0
            })
        },
        editRecord(value) {
            this.$router.push({
                name: "EditSVDLocationMapping",
                params: {
                    svdlocationMappingId: value.id,
                    currentSVDLocationMapping: {
                        pto_name: value.pto_name,
                        merchant_id: value.merchant_id,
                        merchant_code: value.merchant_code,
                        merchant_name: value.merchant_name,
                        location_id: value.location_id,
                        location_name: value.location_name,
                    },
                }
            });
        },
        exportCSV() {
            let newUrl = url.svd.svd_location_mapping.list + "?page=" + 1 + "&limit=" + this.totalData
            AxiosCall.Get(newUrl).then(res => {
                this.locationMappingCSV = [];
                if (res.data.length !== 0) {
                    this.totalData = parseInt(res.data.total)
                    let no = 1 + ((res.data.page - 1) * res.data.perPage)
                    for (let data of res.data.data) {
                        data.no = no
                        this.locationMappingCSV.push({
                            NO: data.no,
                            "PTO NAME": data.pto_name,
                            "MERCHANT ID": data.merchant_id,
                            "MERCHANT CODE": data.merchant_code,
                            "MERCHANT NAME": data.merchant_name,
                            "LOCATION ID": data.location_id,
                            "LOCATION NAME": data.location_name
                        });
                        no++
                    }
                }
                let exportData = XLSX.utils.json_to_sheet(this.locationMappingCSV)
                let exportDataCSV = XLSX.utils.sheet_to_csv(exportData)

                const url = window.URL.createObjectURL(new Blob([exportDataCSV]));
                const link = document.createElement('a');
                link.href = url;
                let file_name = 'svd-location-mapping.csv'
                link.setAttribute('download', file_name);
                document.body.appendChild(link);
                link.click()
                link.remove()
            }).catch(() => {
                console.log("failed export data")

            })
        },
        uploadCSV() {
            this.showPopUp = true
        },
        handleFileUpload(file) {
            let payload = {
                file: file
            }
            this.file = payload
        },
        handleDelete(file, title) {
            if (title === this.documents[0].name) {
                this.documents[0].file_name = ""
                this.documents[0].url = ""
            }

            this.file = null
        },
        submitRequest() {
            if ((this.file.file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") && (this.file.file.type !== "application/wps-office.xlsx")) {
                this.$vs.notify({
                    title: "Failed",
                    text: "File must be in .xlxs format !",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-right"
                });
                this.forceRerender()
                this.showPopUp = false
                this.file = null
            } else {
                FileAPI.UploadSVDLocationMapping(this.file).then((result) => {
                    this.$vs.loading.close()
                    if (result.code === 200) {
                        this.forceRerender()
                        this.file = null
                        this.$store.dispatch('createAuditTrail', {
                            user_id: JSON.parse(localStorage.getItem('userInfo')).id,
                            session_id: parseInt(localStorage.getItem('sessID')),
                            user_name: JSON.parse(localStorage.getItem('userInfo')).displayName,
                            menu: "SVD Location Mapping",
                            activity: "Add Bulk SVD Location Mapping",
                            data_before: {},
                            data_after: result.data,
                        })
                        this.showPopUp = false
                        swal.fire({
                            type: 'success',
                            title: 'Success!',
                            text: 'Create Location Mapping Success!',
                        })
                    }
                }).catch(error => {
                    this.$vs.loading.close()
                    this.forceRerender()
                    this.file = null
                    this.showPopUp = false
                    this.$vs.notify(error.response.data.notify)
                })
            }
        },
        toColumnName(num) {
            let ret = ''
            for (let a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
                ret = String.fromCharCode(parseInt((num % b) / a) + 65) + ret;
            }
            return ret;
        },
        downloadExcel() {
            let workbook = new Excel.Workbook();
            workbook.creator = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.lastModifiedBy = JSON.parse(localStorage.getItem("userInfo")).displayName;
            workbook.created = new Date();
            workbook.modified = new Date();
            workbook.lastPrinted = new Date();

            workbook.properties.date1904 = true;
            let sheet = workbook.addWorksheet('Sheet1', { properties: { tabColor: { argb: 'FFC0000' } } });
            let sheetRef = workbook.addWorksheet('Contoh Pengisian', { properties: { tabColor: { argb: 'FFC0000' } } });
            let font = { name: 'Consolas', size: 10 };
            let row = 7

            sheet.getCell('A1').value = 'Merchant ID'
            sheet.getCell('B1').value = 'Location ID'

            sheetRef.getCell('A1').value = 'Merchant ID'
            sheetRef.getCell('A2').value = '570'
            sheetRef.getCell('A3').value = '620'
            sheetRef.getCell('A4').value = '600'
            sheetRef.getCell('A5').value = '594'
            sheetRef.getCell('A6').value = '565'

            sheetRef.getCell('B1').value = 'Location ID'
            sheetRef.getCell('B2').value = '20021'
            sheetRef.getCell('B3').value = '10000'
            sheetRef.getCell('B4').value = '30000'
            sheetRef.getCell('B5').value = '40000'
            sheetRef.getCell('B6').value = '30330'

            for (let i = 1; i <= 60; i++) {
                for (let a = 1; a <= row; a++) {
                    sheet.getCell(this.toColumnName(i) + "" + a).font = font
                    sheetRef.getCell(this.toColumnName(i) + "" + a).font = font
                }
            }

            workbook.xlsx.writeBuffer().then((buf) => {
                saveAs(new Blob([buf]), `sample_svd_location_mapping_file.xlsx`);
            });
        }
    },
    mounted() {
        if (this.$route.params.status) {
            this.$vs.notify({
                title: "Success",
                text: this.$route.params.message,
                color: "success",
                position: "top-right"
            });
        }
        this.gridApi = this.gridOptions.api;
        this.gridOptions.getRowStyle = function (params) {
            if (params.node.rowIndex % 2 === 0) {
                return { background: '#f9f9f9' }
            }
        }
        this.fetchData(1, 20)

        this.$root.$on("edit-from-ActionTableAgGridComponent", data => {
            this.editRecord(data)
        });
    }
}
</script>

<style>
.vdp-datepicker input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%
}

.flatpickr-input {
    padding: .7rem;
    font-size: 1rem;
    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.2);
    color: #626262;
    width: 100%;
}

.vue-simple-suggest.designed .suggestions {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    top: calc(100% + 5px);
    border-radius: 3px;
    border: 1px solid #aaa;
    background-color: #fff;
    opacity: 1;
    z-index: 1000;
    overflow: scroll;
    height: 300px;
}

.cell-wrap-text {
    white-space: pre-wrap !important;
}
</style>

